var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRepo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "56px",
    viewBox: "0 0 42 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/repo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home/Onboarding/Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-2.0-Empty-PR-GitHub-org-not-connected",
    transform: "translate(-743.000000, -938.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(109.000000, 773.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/repo",
    transform: "translate(627.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "repo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5,14 L21,14 L21,17.5 L24.5,17.5 L24.5,14 Z M24.5,7 L21,7 L21,10.5 L24.5,10.5 L24.5,7 Z M45.5,0 C43.75,0 12.25,0 10.5,0 C8.75,0 7,1.75 7,3.5 C7,5.25 7,43.75 7,45.5 C7,47.25 8.75,49 10.5,49 C12.25,49 17.5,49 17.5,49 L17.5,56 L22.75,50.75 L28,56 L28,49 C28,49 43.75,49 45.5,49 C47.25,49 49,47.25 49,45.5 C49,43.75 49,5.25 49,3.5 C49,1.75 47.25,0 45.5,0 Z M45.5,43.75 C45.5,44.625 44.67925,45.5 43.75,45.5 C42.82075,45.5 28,45.5 28,45.5 L28,42 L17.5,42 L17.5,45.5 C17.5,45.5 13.17925,45.5 12.25,45.5 C11.32075,45.5 10.5,44.57075 10.5,43.75 C10.5,42.92925 10.5,38.5 10.5,38.5 L45.5,38.5 C45.5,38.5 45.5,42.875 45.5,43.75 Z M45.5,35 L17.5,35 L17.5,3.5 L45.55425,3.5 L45.5,35 Z M24.5,28 L21,28 L21,31.5 L24.5,31.5 L24.5,28 Z M24.5,21 L21,21 L21,24.5 L24.5,24.5 L24.5,21 Z",
    id: "Shape",
    fill: "#DEE3EC",
    fillRule: "nonzero"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepo);
export default __webpack_public_path__ + "static/media/repo.d7d5f755.svg";
export { ForwardRef as ReactComponent };